import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import 'leaflet-gesture-handling';
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css';

import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Fix default marker icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

// ✳️ Belangrijk: hook GestureHandling in Leaflet zelf
import { GestureHandling } from 'leaflet-gesture-handling';
L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);

const center = [51.118352, 3.748370];

const LeafletMap = () => {
  return (
    <div style={{ width: '100%', height: '400px' }}>
      <MapContainer
        center={center}
        zoom={12}
        style={{ height: '100%', width: '100%' }}
        // ✳️ Hier activeren we gestureHandling rechtstreeks
        gestureHandling={true} // dit werkt NIET
        // ✅ juiste manier:
        whenCreated={(mapInstance) => {
          mapInstance.options.gestureHandling = true;
          mapInstance.gestureHandling.enable();
        }}
      >
        <TileLayer
          attribution="&copy; OpenStreetMap, &copy; CARTO"
          url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
        />
        <Marker position={center}>
          <Popup>Auto-Service Thomas</Popup>
        </Marker>
      </MapContainer>
    </div>
  );
};

export default LeafletMap;
